/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-group.form-group--date-picker[_ngcontent-%COMP%]   .form-group--date-picker__group[_ngcontent-%COMP%]{width:94%;border-right:1px solid #ccc!important}.btn-filters[_ngcontent-%COMP%]{float:right;padding:1px;margin:1px}.form-group--date-picker__Single[_ngcontent-%COMP%]{width:100%!important}.search__button[_ngcontent-%COMP%]{color:#005cab;position:absolute;bottom:10px;right:10px;z-index:4;font-size:14px;cursor:pointer}.form-group[_ngcontent-%COMP%]{margin-bottom:0}"];
export { styles as styles };
